import { useDispatch } from "react-redux";
import { clearBalance, setBalance, setLastProcessedStore } from "..";

export const useBalanceActions = () => {
  const dispatch = useDispatch();

  const updateBalance = (balance: {
    previousBalance: string;
    entries: string;
    exits: string;
    dailyClosing: string;
    dailyBalance: string;
    createdAt: Date;
    expiresAt: Date;
  } | null) => {
    dispatch(setBalance(balance));
  };

  const updateLastProcessedStore = (storeCode: string | null) => {
    dispatch(setLastProcessedStore(storeCode));
  };

  const resetBalance = () => {
    dispatch(clearBalance());
  };

  return {
    updateBalance,
    updateLastProcessedStore,
    resetBalance,
  };
};
